import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=42f6185c&"
import script from "./exchange.vue?vue&type=script&lang=js&"
export * from "./exchange.vue?vue&type=script&lang=js&"
import style0 from "./exchange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports